module.exports = ".pagination li.active {\n  background-color: #00713c !important; }\n\ntd, th {\n  padding: 1px 5px;\n  font-weight: normal; }\n"